import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {GraphQLModule} from './graphql.module';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {HttpConfigInterceptor} from './shared/providers/httpconfig.interceptor';
import * as Sentry from '@sentry/angular';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HomeComponent} from './home/home.component';
import {ClientListComponent} from './client-list/client-list.component';
import {NewClientComponent} from './new-client/new-client.component';
import {ClientDetailComponent} from './client-detail/client-detail.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToastrModule} from 'ngx-toastr';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {ClientProgressComponent} from './client-detail/client-progress/client-progress.component';
import {ClientEditComponent} from './client-detail/client-edit/client-edit.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {BuddyPageComponent} from './buddy-page/buddy-page.component';
import {AutosizeModule} from 'ngx-autosize';
import {DateToStringPipe} from './shared/pipes/date-to-string.pipe';
import {InstructionsComponent} from './instructions/instructions.component';
import {RegisterComponent} from './register/register.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TenantListComponent} from './tenant-list/tenant-list.component';
import {TenantDetailComponent} from './tenant-list/tenant-detail/tenant-detail.component';
import {CoachEditComponent} from './tenant-list/tenant-detail/coach-edit/coach-edit.component';
import {NewCoachComponent} from './tenant-list/tenant-detail/new-coach/new-coach.component';
import {SearchBarComponent} from './search-bar/search-bar.component';
import {ChatroomComponent} from './chatroom/chatroom.component';
import {ClientChatComponent} from './client-detail/client-chat/client-chat.component';
import {SlideToggleComponent} from './shared/components/slide-toggle/slide-toggle.component';
import {QuestionnaireListComponent} from './questionnaire-list/questionnaire-list.component';
import {NewQuestionnaireComponent} from './questionnaire-list/new-questionnaire/new-questionnaire.component';
import {MessageComponent} from './chatroom/message/message.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NewClientComponent,
    ClientDetailComponent,
    ClientListComponent,
    ClientProgressComponent,
    ClientEditComponent,
    BuddyPageComponent,
    DateToStringPipe,
    InstructionsComponent,
    RegisterComponent,
    SearchBarComponent,
    ChatroomComponent,
    ClientChatComponent,
    SlideToggleComponent,
    TenantListComponent,
    TenantDetailComponent,
    CoachEditComponent,
    NewCoachComponent,
    QuestionnaireListComponent,
    NewQuestionnaireComponent,
    MessageComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GraphQLModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      preventDuplicates: true,
    }),
    ModalModule.forRoot(),
    NgxIntlTelInputModule,
    NgSelectModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'nl',
    }),
    AutosizeModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
